import { z } from 'zod';
import { Validation } from '@mews/framework';
import { AccountNoteCustomerClassifications } from '@mews-commander/data-access';
import { maxAccountNoteInputLength } from '@mews-commander/legacy-form';

export enum FieldNames {
    content = 'content',
    classification = 'classification',
}

export const accountNoteFormSchema = z.object({
    [FieldNames.content]: Validation.String.Required.max(maxAccountNoteInputLength.maximum),
    [FieldNames.classification]: z.nativeEnum(AccountNoteCustomerClassifications),
});

export type AccountNoteFormValues = z.infer<typeof accountNoteFormSchema>;
